import {
  GenericAddressControl
} from "core/controls/GenericAddressControl";

import {
  GenericNamePhoneControl
} from "core/controls/GenericNamePhoneControl";

export const AddressControl = [
  ...GenericAddressControl,
  ...GenericNamePhoneControl
];
